import clsx from "clsx";

type Props = {
  onClick: () => void;
  label: string;
  isActive?: boolean;
};

export default function PlayerMenuHeaderTab({ label, onClick, isActive }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx("text-12 font-extrabold uppercase transition-all overflow-clip", {
        "text-accent-solid": isActive,
      })}
      style={{
        backgroundImage: isActive ? "url(./svg/player-menu/header-tab.svg)" : "none",
        backgroundPosition: "bottom",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
      }}
    >
      {label}
    </button>
  );
}
